// Bulk tracking-legs editor strings (auto-merged by lib/i18n.ts).
export const en = {
  'operator.bulk_steps.add': 'Add leg',
  'operator.bulk_steps.save': 'Save legs',
  'operator.bulk_steps.cancel': 'Cancel',
  'operator.bulk_steps.remove': 'Remove leg {n}',
  'operator.bulk_steps.drag': 'Drag to reorder leg {n}',
}

export const zhTW = {
  'operator.bulk_steps.add': '新增航段',
  'operator.bulk_steps.save': '儲存航段',
  'operator.bulk_steps.cancel': '取消',
  'operator.bulk_steps.remove': '移除航段 {n}',
  'operator.bulk_steps.drag': '拖曳以重新排序航段 {n}',
}
